import React from "react";
import ReactDOM from "react-dom/client";
import { MantineProvider, Global } from "@mantine/core";
import App from "./App";
import "./index.css";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <MantineProvider
    withGlobalStyles
    withNormalizeCSS
    theme={{
      fontFamily: "'Poppins', sans-serif",
      primaryColor: "brand",
      colors: {
        brand: [
          "#e8edf5",
          "#c5d0e6",
          "#a0b2d6",
          "#7a93c6",
          "#5575b6",
          "#3358a6",
          "#1e4496",
          "#0e3070",
          "#061c41",
          "#03102a",
        ],
      },
    }}
  >
    {/* Set global styles including body background */}
    <Global
      styles={{
        body: {
          backgroundColor: "#ffffff",
          fontFamily: "'Poppins', sans-serif",
        },
      }}
    />

    <App />
  </MantineProvider>
);
